export default {
	"18838ed4a2bbcecf9f2fd03095c9ee99": "已阅读并同意",
	"e69cd9cc1acea3c54a1a5636d5cfd594": "《用户服务协议》",
	"46a8e8392001c13c67f883e9e2d62285": "《自动续费协议》",
	"b72be4162301b6d49a3956896000d13a": "《用户购买协议》"
}
